// headerPulse.js — Randomized energy pulse running along nav divider

const MIN_DELAY = 7000;
const MAX_DELAY = 25000;

function randomDelay() {
  return Math.floor(MIN_DELAY + Math.random() * (MAX_DELAY - MIN_DELAY));
}

export function initHeaderPulse() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const nav = document.getElementById('site-nav');
  if (!nav) return;

  const pulse = document.createElement('span');
  pulse.className = 'nav-divider-pulse';
  pulse.setAttribute('aria-hidden', 'true');
  nav.appendChild(pulse);

  let timer = null;

  function getTravelBounds() {
    const navWidth = nav.getBoundingClientRect().width;
    const pulseWidth = pulse.getBoundingClientRect().width || 26;
    const overshoot = pulseWidth + 18;

    return {
      start: `${-overshoot}px`,
      end: `${Math.ceil(navWidth + overshoot)}px`,
    };
  }

  const schedule = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(runPulse, randomDelay());
  };

  const runPulse = () => {
    const { start, end } = getTravelBounds();
    pulse.style.setProperty('--pulse-from', start);
    pulse.style.setProperty('--pulse-to', end);
    pulse.classList.remove('is-animating');
    // restart animation
    void pulse.offsetWidth;
    pulse.classList.add('is-animating');
    schedule();
  };

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (timer) clearTimeout(timer);
      timer = null;
      pulse.classList.remove('is-animating');
    } else {
      schedule();
    }
  });

  schedule();
}
